import { createFileRoute } from '@tanstack/react-router'
import { EmailUnsubscribePage } from '../components/email-pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/disiscrizione')({
  head: () => noIndexRouteHead('emailUnsubscribe', 'it'),
  component: EmailUnsubscribePage,
})
